import type { Seat } from "@ravalmatic/bridge-engine/core";

export type TransitionRequest = {
    readonly kind: "transition";
    readonly token: symbol;
};

export type TrickCollectionRequest = {
    readonly kind: "trick-collection";
    readonly token: symbol;
    readonly trickNumber: number;
    readonly winner: Seat;
};

export type TrickCollectionCallbacks = {
    onCollapsed: (request: TrickCollectionRequest) => void;
    onComplete: (request: TrickCollectionRequest) => void;
};

export type AnimationStep = (onComplete: () => void) => void;

export class AnimationBarrier {

    private started = false;
    private cancelled = false;

    public run(steps: readonly AnimationStep[], onComplete: () => void): void {

        if (this.started) {
            throw new Error("Animation barrier has already started");
        }
        this.started = true;
        if (this.cancelled) {
            return;
        }
        let pending = steps.length;
        if (pending === 0) {
            onComplete();
            return;
        }
        for (const step of steps) {
            if (this.cancelled) {
                break;
            }
            let completed = false;
            step(() => {
                if (completed || this.cancelled) {
                    return;
                }
                completed = true;
                pending--;
                if (pending === 0) {
                    onComplete();
                }
            });
        }
    }

    public cancel(): void {

        this.cancelled = true;
    }
}
